import type { Tempo } from '../../shared/tempo';
import type { PlayerState } from '../state';

export interface ClockReading {
  night: boolean;
  into: number;
  // False only on the first day of the set.
  flipped: boolean;
}

// It reads the tick only, so it is the same for every player, online too.
export function readClock(
  time: number,
  tempo: Pick<Tempo, 'ticksPerBar' | 'originTick'>,
  clock: PlayerState['clock'],
  halfBars: number,
): ClockReading {
  const half = halfBars * tempo.ticksPerBar;
  const elapsed = Math.max(0, time - (clock?.fromTick ?? tempo.originTick));
  const halves = Math.floor(elapsed / half);
  return {
    night: (clock?.night ?? false) !== (halves % 2 === 1),
    into: elapsed - halves * half,
    flipped: clock !== undefined || halves > 0,
  };
}

// Within a beat of a flip of the clock itself, the Éclipse is that flip: only the count restarts.
export function flipClock(
  player: PlayerState,
  tick: number,
  tempo: Pick<Tempo, 'ticksPerBar' | 'ticksPerBeat' | 'originTick'>,
  halfBars: number,
): void {
  const { night, into, flipped } = readClock(tick, tempo, player.clock, halfBars);
  player.clock = { night: flipped && into < tempo.ticksPerBeat ? night : !night, fromTick: tick };
}
